import { address } from "@repo/models";
import { TextBox } from "@repo/ui";
import { FC, useCallback, useMemo } from "react";

import { Autocomplete } from "./autocomplete";
import { AutocompleteItem } from "./types";

interface Props {
	id: string;
	value: address;
	defaultZip?: string;
	validationError?: string;
	disabled: boolean;
	readOnly: boolean;
	changeHandler: (value: address, id?: string) => void;
}

export const AddressAutocomplete: FC<Props> = ({
	id,
	value,
	defaultZip,
	disabled,
	readOnly,
	validationError,
	changeHandler,
}) => {
	const onChange = useCallback(
		(newVal: AutocompleteItem) => {
			const address = {
				...newVal,
				address1: newVal.addressLine1,
				address2: newVal.addressLine2,
				stateName: newVal.state,
				stateId: null,
			} as address;
			changeHandler(address);
		},
		[changeHandler],
	);

	const mappedAddress = useMemo(
		() =>
			({
				...value,
				addressLine1: value.address1,
				addressLine2: value.address2,
				state: value.stateName,
				entries: undefined,
			}) as AutocompleteItem,
		[value],
	);

	return (
		<div id={id}>
			<Autocomplete
				id={id}
				value={mappedAddress}
				defaultZip={defaultZip}
				validationError={validationError}
				disabled={disabled}
				readOnly={readOnly}
				changeHandler={onChange}
			/>
			<TextBox label="Address Line 1" value={value?.address1} disabled className="w-100" />
			<TextBox label="Address Line 2" value={value?.address2} disabled className="w-100" />
			<TextBox label="City" value={value?.city} disabled className="w-100" />
			<TextBox label="State" value={value?.stateName} className="w-100" disabled />
			<TextBox label="Zip" value={value?.zip} disabled className="w-100" />
		</div>
	);
};
